<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { NXGDSModal } from '@nsftx/seven-nxg-design-system'
import { useSlipCheckStore } from '@/stores/slip-check/slipCheckStore'
import { useBetslip, useGame, useGamesStore } from '@nsftx/seven-client-retail-vue-sgp'
import i18n from '@/plugins/translationsPlugin'
import SSSlipDetailsModalHeader from './SSSlipDetailsModalHeader.vue'
import SSSlipDetailsModalFooter from './SSSlipDetailsModalFooter.vue'
import SSSlipDetailsTable from './SSSlipDetailsTable.vue'
import type { Bet } from '@nsftx/seven-client-retail-vue-integrator'

const { t } = i18n.global
const slipCheckStore = useSlipCheckStore()
const { isSlipCheckDetailsOpened } = storeToRefs(slipCheckStore)
const { bets, isMultibet, betslipProductId, getBetType } = useBetslip()
const { getGameById, getGameLinkByDisplayId } = useGamesStore()

const game = getGameById(betslipProductId.value ?? 0)
const gameLink = getGameLinkByDisplayId(game?.displayId ?? '')
const { gameDisplayName } = useGame(gameLink)

const getGameTitle = (bet: Bet) => {
  const betType = getBetType(bet)

  return `${gameDisplayName.value} (${t(`bet_type_${betType.toLowerCase()}`)})`
}
</script>

<template>
  <NXGDSModal
    v-model="isSlipCheckDetailsOpened"
    :show-close-button="true"
    :close-on-outside-click="true"
    width="1200px"
  >
    <template #header>
      <SSSlipDetailsModalHeader />
    </template>
    <div class="ss-slip-details-modal__content">
      <div v-for="(bet, index) in bets" :key="bet.id" class="ss-slip-details-modal__bet-section">
        <h4 v-if="isMultibet" class="ss-slip-details-modal__bet-title">
          {{ t('slip_check_details_bet_title', { index: index + 1, title: getGameTitle(bet) }) }}
        </h4>
        <SSSlipDetailsTable :bet="bet" />
      </div>
    </div>
    <template #footer>
      <SSSlipDetailsModalFooter />
    </template>
  </NXGDSModal>
</template>

<style lang="scss">
@use '@nsftx/seven-nxg-design-system/style/mixins' as *;

.ss-slip-details-modal {
  &__content {
    display: flex;
    flex-direction: column;
    gap: var(--nxgds-alias-spacing-lg);
  }

  &__bet-section {
    display: flex;
    flex-direction: column;
    gap: var(--nxgds-alias-spacing-xs);
  }

  &__bet-title {
    @include typography('h4', 'medium');
    color: var(--nxgds-mapped-color-text-secondary);
  }
}
</style>
